import {Component} from '@angular/core';
import {Observable} from "rxjs";
import {RestResponse} from "../../../Interfaces/RestResponse.interface";
import RestHelper from "../../../Helper/RestHelper";
import {HttpClient} from "@angular/common/http";
import {LoaderService} from "../../../services/loader/loader.service";
import {Router} from "@angular/router";
import {Customer} from "../../../Interfaces/customer.interface";
import Helper from "../../../Helper/Helper";
import PermissionsHelper from "../../../Helper/PermissionsHelper";
import Utils from "../../../Helper/Utils";

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrl: './customers.component.css'
})
export class CustomersComponent {

  constructor(private httpClient: HttpClient, protected loader: LoaderService, public router: Router) {
    this.loader.showLoader()
    this.customers = this.getCustomers()
  }

  public customers: Observable<Customer[]> | undefined
  public apierror: boolean = true
  public showarchived: boolean = false

  private getCustomers(sortby: string = "", sorttype: string = ""): Observable<Customer[]> {

    const urlSearchParams = new URLSearchParams();

    if (sortby !== "") {
      urlSearchParams.set("sortby", sortby);
    }
    if (sorttype !== "") {
      urlSearchParams.set("sorttype", sorttype);
    }

    urlSearchParams.set("archived", String(this.showarchived));

    console.log(urlSearchParams.toString())

    return new Observable(subscriber => {

      this.httpClient.get<RestResponse<Customer[]>>(RestHelper.API_BASE_URL + "customer/getCustomer?" + urlSearchParams.toString(), RestHelper.requestOptions).subscribe({
        next: (value) => {
          subscriber.next(value.data)
          this.loader.hideLoader()
        }, error: () => {
          this.apierror = true
          this.loader.hideLoader()
        }
      })
    })
  }

  public changeArchivedStatus(event: Event, customer: Customer) {

    event.preventDefault()
    event.stopPropagation();

    const input = event.target as HTMLInputElement;
    const body = new FormData();

    body.append("uuid", customer.uuid)
    body.append("archived", String(input.checked))

    this.httpClient.patch(RestHelper.API_BASE_URL + 'customer/updateCustomer', body, RestHelper.requestOptions)
      .subscribe({
        next: () => {
          input.checked = !input.checked
          customer.archived = input.checked
          if(input.checked && !this.showarchived) {
            input.parentElement?.parentElement?.remove();
          }
        },
        error: (err) => {
          console.error(err)
        }
      });
  }

  public changeShowArchivedStatus(event: Event) {
    const input = event.target as HTMLInputElement;
    this.showarchived = input.checked
    this.customers = this.getCustomers(this.lastsort, this.lastsorttype)
  }

  public lastsort: string = ""
  public lastsorttype = ""

  public sortTablebyColum(property: string) {
    let sorttype: string;
    if (this.lastsort === property) {
      if (this.lastsorttype === "ASC") {
        sorttype = "DESC";
      } else {
        sorttype = "ASC"
      }
    } else {
      sorttype = "ASC"
    }
    this.lastsort = property
    this.lastsorttype = sorttype;
    this.customers = this.getCustomers(property, sorttype)
  }

  protected readonly Helper = Helper;
  protected readonly PermissionsHelper = PermissionsHelper;

  protected readonly Utils = Utils;
}
